import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import handImage from '../../assets/imgs/img_hand.png';

import { useTranslation } from 'react-i18next';

export default function LandingTechnologiesBanner() {
  const { t } = useTranslation();

  return (
    <BannerSection id='technologies'>
      <BannerContainer>
        <BannerText>
          {t('informationServices.technologiesBanner.text1')}
        </BannerText>
        <BannerText>
          {t('informationServices.technologiesBanner.text2')}
        </BannerText>
        <BannerText>
          {t('informationServices.technologiesBanner.text3')}
        </BannerText>
      </BannerContainer>
    </BannerSection>
  );
}

const BannerSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  [theme.breakpoints.down('md')]: {
    padding: '100px 0 0',
  },
}));
const BannerText = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: 100,
  color: theme.palette.primary.main,

  [theme.breakpoints.down('md')]: {
    fontSize: 60,
  },
}));
const BannerContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(2, 20),
  background: `url(${handImage})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  minHeight: '640px',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2, 4),
    minHeight: '400px',
    marginRight: '0',
  },
}));
